import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { ORDER_TYPE_IDS } from '../Utils/Constants/Order';
import { ORDER_TYPE_DELIVERY, ORDER_TYPE_DELIVERY_ID, ORDER_TYPE_DINE_IN, ORDER_TYPE_DINE_IN_ID, ORDER_TYPE_ICONS, ORDER_TYPE_LABELS, ORDER_TYPE_STORE_COUNTER, ORDER_TYPE_STORE_COUNTER_ID } from '../Utils/Constants/Service';
import { useLayoutContext } from './LayoutContext';

interface OrderTypeType {
  orderType: string;
  setOrderType: CallableFunction;
  getOrderTypeIdByName: (value: string) => void;
  isStoreCounter: boolean;
  setIsStoreCounter: CallableFunction;
  setIsDelivery: CallableFunction;
  isDelivery: boolean;
  setIsDinein: CallableFunction;
  isDinein: boolean;

  enabledOrderType: any;
  setEnabledOrderType: CallableFunction;
  visibleOrderType: any;
  setVisibleOrderType: CallableFunction;

  showTakeoutModeOptions: boolean;
  setShowTakeoutModeOptions: (value: any) => void;
  takeoutMode: string;
  setTakeoutMode: (value: any) => void;
}

const OrderTypeContext = createContext<OrderTypeType | undefined>(undefined);

export const OrderTypeProvider = ({ children }: { children: ReactNode }) => {

  const [orderType, setOrderType] = useState(() => {
    const storedOrderType = localStorage.getItem('order_type');
    return storedOrderType !== null ? storedOrderType : '';
  });

  const getOrderTypeIdByName = (orderType: string): number | null => {
    return ORDER_TYPE_IDS[orderType] ?? null;
  }

  const [ isStoreCounter, setIsStoreCounter] = useState(false);
  const [ isDelivery, setIsDelivery] = useState(false);
  const [ isDinein, setIsDinein] = useState(false);

  useEffect(() => {
    if (orderType) {
      localStorage.setItem('order_type', orderType)
    }
    setIsStoreCounter(orderType === ORDER_TYPE_STORE_COUNTER);
    setIsDelivery(orderType === ORDER_TYPE_DELIVERY);
    setIsDinein(orderType === ORDER_TYPE_DINE_IN);
  }, [orderType])

  const { company } = useLayoutContext();
  const [ enabledOrderType, setEnabledOrderType ] = useState<any[]>([]); //* Lista de serviços ativos obtidos na company.service_*
  const [ visibleOrderType, setVisibleOrderType ] = useState<any[]>([]); //* Utilizado para exibição e navegação (startPage / cardStore)

  const [ showTakeoutModeOptions, setShowTakeoutModeOptions ] = useState<boolean>(false);
  const [ takeoutMode, setTakeoutMode ] = useState(() => {
    const stored = localStorage.getItem('takeout_mode');
    return stored !== null ? stored : '';
  });

  useEffect(() => {
    if (!company) {
      setEnabledOrderType([]);
      return;
    }

    setEnabledOrderType([
      {
        id: ORDER_TYPE_DELIVERY_ID,
        name: ORDER_TYPE_DELIVERY,
        active: company.service_delivery,
        visible: company.service_delivery,
        label: ORDER_TYPE_LABELS[ORDER_TYPE_DELIVERY],
        icon: ORDER_TYPE_ICONS[ORDER_TYPE_DELIVERY]
      },
      // {
      //   id: ORDER_TYPE_TAKEAWAY_ID,
      //   name: ORDER_TYPE_TAKEAWAY,
      //   active: company.service_takeaway,
      //   visible: company.service_takeaway,
      //   label: ORDER_TYPE_LABELS[ORDER_TYPE_TAKEAWAY],
      //   icon: ORDER_TYPE_ICONS[ORDER_TYPE_TAKEAWAY]
      // },
      {
        id: ORDER_TYPE_DINE_IN_ID,
        name: ORDER_TYPE_DINE_IN,
        active: company.service_dinein,
        visible: company.service_dinein,
        label: ORDER_TYPE_LABELS[ORDER_TYPE_DINE_IN],
        icon: ORDER_TYPE_ICONS[ORDER_TYPE_DINE_IN]
      },
      // {
      //   id: ORDER_TYPE_SCHEDULING_ID,
      //   name: ORDER_TYPE_SCHEDULING,
      //   active: orderType === ORDER_TYPE_SCHEDULING,
      //   visible: company.service_scheduling || true,
      //   label: ORDER_TYPE_LABELS[ORDER_TYPE_SCHEDULING],
      //   icon: ORDER_TYPE_ICONS[ORDER_TYPE_SCHEDULING]
      // },
      {
        id: ORDER_TYPE_STORE_COUNTER_ID,
        name: ORDER_TYPE_STORE_COUNTER,
        active: company.service_storecounter,
        visible: false,
        label: ORDER_TYPE_LABELS[ORDER_TYPE_STORE_COUNTER],
        icon: ORDER_TYPE_ICONS[ORDER_TYPE_STORE_COUNTER]
      }
    ]);
  }, [company]);

  useEffect(() => {
    //* Somente orderTypes visíveis
    if (enabledOrderType.length > 0) {
      const visibleServices = enabledOrderType.filter((service: any) => service.visible)
      setVisibleOrderType(visibleServices);
    }
  }, [enabledOrderType]);

  useEffect(() => {
    if (takeoutMode && orderType === ORDER_TYPE_DINE_IN) {
      localStorage.setItem('takeout_mode', takeoutMode);
    } else {
      setTakeoutMode('');
      localStorage.removeItem('takeout_mode');
    }
  }, [takeoutMode, orderType]);

  return (
    <OrderTypeContext.Provider value={{ 
        orderType, setOrderType, 
        getOrderTypeIdByName, 
        isStoreCounter, setIsStoreCounter, 
        isDelivery, setIsDelivery, 
        isDinein, setIsDinein, 
        enabledOrderType, setEnabledOrderType, 
        visibleOrderType, setVisibleOrderType,
        showTakeoutModeOptions, setShowTakeoutModeOptions,
        takeoutMode, setTakeoutMode
      }}>
      {children}
    </OrderTypeContext.Provider>
  );
};

export const useOrderTypeContext = () => {
  const context = useContext(OrderTypeContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
